import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import axiosInstance from "../helpers/axios";
import { hasReviewerAdminAccess, reviewerAdminPaths } from "../helpers/portalAccess";

function Protected({ children, allowedRoles }) {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [checkedPath, setCheckedPath] = useState(null);
  const employee = auth.user?.role === "employee";

  useEffect(() => {
    if (!employee) return;
    let active = true;
    const refreshAccess = async () => {
      try {
        const { data } = await axiosInstance.get("/session/access", { memberRequest: true });
        if (active) {
          dispatch({ type: "REFRESH_ADMIN_ACCESS", payload: data.adminAccess === true });
          setCheckedPath(pathname);
        }
      } catch {
        if (active) {
          dispatch({ type: "REFRESH_ADMIN_ACCESS", payload: false });
          setCheckedPath(pathname);
        }
      }
    };
    refreshAccess();
    window.addEventListener("focus", refreshAccess);
    return () => { active = false; window.removeEventListener("focus", refreshAccess); };
  }, [employee, auth.user?._id, pathname, dispatch]);

  if (!auth.user) return <Navigate to="/" replace />;
  if (employee && checkedPath !== pathname) return null;
  const delegated = hasReviewerAdminAccess(auth.user) && reviewerAdminPaths.includes(pathname);
  if (allowedRoles && !allowedRoles.includes(auth.user.role) && !delegated) {
    return <Navigate to={employee ? "/resource/addtime" : "/adminDashboard"} replace />;
  }
  return children;
}
export default Protected;
